import React, { useState, useEffect } from 'react';

import Autocomplete from '../ui/Autocomplete';
import NuxeoClient from '../../clients/NuxeoClient';

import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import InputLabel from '@material-ui/core/InputLabel';

import { useI18n } from '../../I18nProvider';

export default function AssociatedJobs(props) {

    const appText = useI18n();
    const [timeID, setTimeID] = useState([]);
    const [fetchedData, setFetchedData] = useState([]);

    useEffect(() => {
        _loadAssociatedJobs()
    }, []);

    async function _loadAssociatedJobs(input = "") {
        await NuxeoClient
            .instance()
            .fetchAssociatedJobs(input)
            .then((response) => {
                setFetchedData(response.entries);
            });
    };

    const loadAssociatedJobs = input => {

        setTimeID(timeID => [...timeID, setTimeout(() => {
            _loadAssociatedJobs(input)
        }, 2000)]);

        timeID.forEach(id => window.clearTimeout(id));
    };

    const handleChange = (jobs) => {

        if (jobs === null) {

            props.handleChange('associatedJobs', []);
            props.handleChange('associatedJobsID', []);

        } else if (jobs.length > props.value.length) {

            let values = [...props.value];
            values.push(jobs[jobs.length - 1].label);
            props.handleChange('associatedJobs', values);

            let ids = [...props.id];
            ids.push(jobs[jobs.length - 1].id);
            props.handleChange('associatedJobsID', ids);

        } else {

            const jobLabels = jobs.map(job => job = job.label);
            const deletedJob = props.value.filter(value => !jobLabels.includes(value));

            let deletedIndex;
            let values = [...props.value];
            props.value.forEach((value, index) => {
                if (value === deletedJob[0]) {
                    deletedIndex = index;
                    values.splice(index, 1);
                }
            })
            props.handleChange('associatedJobs', values);

            let ids = [...props.id];
            ids.splice(deletedIndex, 1);
            props.handleChange('associatedJobsID', ids);
        }
    }

    return (
        <Tooltip arrow title={appText.T126}>
            <Grid item={true} xs={12}>
                <div id="associatedJobs">
                    <InputLabel className="field-label field-dropdown">
                        {/* Associated Jobs */}
                        {appText.T66}
            </InputLabel>
                    <Autocomplete
                        type={'multi'}
                        handleChange={handleChange}
                        data={fetchedData}
                        dataType={'associatedJobs'}
                        mapVariable={'title'}
                        setFilterData={loadAssociatedJobs}
                        value={props.value}
                        isLoading={false}
                    />
                </div>
            </Grid>
        </Tooltip>
    );
};